import { render, staticRenderFns } from "./pc_sub.vue?vue&type=template&id=0b7e32e4&scoped=true&"
import script from "./pc_sub.vue?vue&type=script&lang=js&"
export * from "./pc_sub.vue?vue&type=script&lang=js&"
import style0 from "./pc_sub.vue?vue&type=style&index=0&id=0b7e32e4&scoped=true&lang=scss&"
import style1 from "./pc_sub.vue?vue&type=style&index=1&id=0b7e32e4&lang=scss&"
import style2 from "./pc_sub.vue?vue&type=style&index=2&id=0b7e32e4&lang=scss&"
import style3 from "./pc_sub.vue?vue&type=style&index=3&id=0b7e32e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7e32e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhangenlong/vhall/saas-sdk-questionnaire/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b7e32e4')) {
      api.createRecord('0b7e32e4', component.options)
    } else {
      api.reload('0b7e32e4', component.options)
    }
    module.hot.accept("./pc_sub.vue?vue&type=template&id=0b7e32e4&scoped=true&", function () {
      api.rerender('0b7e32e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pc_sub.vue"
export default component.exports